import React, { useState, useEffect, useRef } from "react";
import { Input, Button, Space } from "antd";
import { makeApiRequest } from "../request/apiRequest";

const NotepadApp = ({ readOnly = false }) => {
  const [title, setTitle] = useState("Untitled");
  const [saved, setSaved] = useState(false);

  const contentEditableRef = useRef(null);

  // Load content from the server file on component mount
  useEffect(() => {
    const fetchContent = async () => {
      try {
        // Use makeApiRequest to fetch the file content
        const responseData = await makeApiRequest(
          'get',
          '/read',
          null, // No data needed for a GET request
          'File content loaded successfully.',
          'Failed to load file content.'
        );
        
        // The API now returns a plain string, not a JSON object
        if (contentEditableRef.current) {
          contentEditableRef.current.innerHTML = responseData;
        }
      } catch (error) {
        console.error("Error fetching content from file:", error);
      }
    };
    fetchContent();
  }, []);

  // This function now uses makeApiRequest to save the content
  const handleSaveToServer = async () => {
    if (!readOnly) {
      const currentContent = contentEditableRef.current
        ? contentEditableRef.current.innerHTML
        : "";
      
      try {
        await makeApiRequest(
          'post',
          '/save',
          { content: currentContent },
          'Content saved to file successfully!',
          'Failed to save content to file.'
        );
        
        setSaved(true);
      } catch (error) {
        console.error("Error saving content:", error);
        setSaved(false);
      }
    }
  };

  const handleBold = () => document.execCommand("bold");
  const handleItalic = () => document.execCommand("italic");
  const handleUnderline = () => document.execCommand("underline");

  return (
    <div style={{ width: "100%", height: "100vh", padding: "20px", direction: "ltr" }}>
      {!readOnly && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "2px solid #ddd",
            paddingBottom: "10px",
          }}
        >
          <Input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            style={{ fontSize: "18px", width: "200px", fontWeight: "bold" }}
          />
          <Space>
            <span style={{ color: saved ? "green" : "red" }}>
              {saved ? "Saved to File" : "Unsaved"}
            </span>
            <Button type="primary" onClick={handleSaveToServer}>
              Save to File
            </Button>
          </Space>
        </div>
      )}

      {!readOnly && (
        <div style={{ marginTop: "10px" }}>
          <Button onClick={handleBold} style={{ marginRight: 8 }}>
            Bold
          </Button>
          <Button onClick={handleItalic} style={{ marginRight: 8 }}>
            Italic
          </Button>
          <Button onClick={handleUnderline}>
            Underline
          </Button>
        </div>
      )}

      <div
        ref={contentEditableRef}
        contentEditable={!readOnly}
        dir="ltr"
        style={{
          marginTop: "20px",
          border: "1px solid #ccc",
          minHeight: "70vh",
          padding: "10px",
          fontSize: "16px",
          backgroundColor: "#fff",
          color: "black",
          direction: "ltr",
          textAlign: "left",
        }}
      />
    </div>
  );
};

export default NotepadApp;